import axiosWithAuth from "../utils/axiosWithAuth";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

/**
 * Aprueba un paso específico en el flujo de trabajo
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {string} step - Nombre del paso a aprobar
 * @returns {Promise<Object>} - Respuesta con el resultado de la aprobación
 */
export const approveStep = async (clientId, orderId, step) => {
  try {
    // Enviar evento para mostrar esqueleto o indicador de carga
    const event = new CustomEvent('stepApproving', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/approve-step`,
      { step }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('stepApproving', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('stepApproving', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al aprobar el paso:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene el flujo de aprobación para una orden específica
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @returns {Promise<Object>} - Respuesta con el flujo de aprobación
 */
export const getApprovalFlow = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto o indicador de carga
    const event = new CustomEvent('approvalFlowLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/approval-step`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('approvalFlowLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('approvalFlowLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener el flujo de aprobación:", error.response?.data || error);
    throw error;
  }
};

/**
 * Envía un correo de notificación cuando un IPR es rechazado o puesto en revisión
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {Object} data - Datos para el correo
 * @param {string} data.requester_email - Email del solicitante
 * @param {string} data.requester_name - Nombre del solicitante
 * @param {string} data.comment - Comentario de rechazo o revisión
 * @param {string} data.status - Estado ('rejected' o 'review')
 * @param {string} data.reviewer_name - Nombre del revisor
 * @param {Array} data.attachments - Archivos adjuntos (opcional)
 * @returns {Promise<Object>} - Respuesta con el resultado del envío
 */
export const sendIPRRejectionEmail = async (clientId, orderId, data) => {
  try {
    // Enviar evento para mostrar indicador de carga
    const event = new CustomEvent('emailSending', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/ipr-rejection`,
      data
    );
    
    // Enviar evento para ocultar indicador de carga
    const endEvent = new CustomEvent('emailSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar indicador de carga en caso de error
    const endEvent = new CustomEvent('emailSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al enviar email de rechazo:", error.response?.data || error);
    throw error;
  }
};
